<template>
  <div>
    <h1>Ticketing Authorization</h1>
    <div v-if="isConfirmed">
      Thank you for completing your ticketing authorization. If you’d like to go back to editing your event, click "My Events" on the navigation menu above, and then select your event.
    </div>
    <div v-else>
      <p class="mb-5">Whether you are hosting free and/or paid events, you must complete this SquadUP ticketing authorization to link your events on our website to SquadUP’s ticketing system. <span class="font-sans-bold">You will only need to do this once</span>, even if you are hosting more than one event.</p>
      <p class="mb-5">Follow the directions in the checkout form below. IMPORTANT: If <span class="font-sans-bold">any</span> of the events you are hosting are paid events (even if some are free):</p>
      <ul class="mb-5">
        <li>As a security measure, you will be required to do a credit card authorization with a $1 charge (fully refunded in 24-48 hours).</li>
        <li>You also will be asked your payout method preference (PayPal, Venmo, or check) and details so that SquadUP can send you your ticketing revenue after the festival!</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CreditAuthorization',
  title: 'Ticketing Authorization',
  props: {},
  data: () => ({
    creditAuthConfirmed: false,
  }),
  computed:{
    ...mapGetters({
      user: 'user'
    }),
    isConfirmed() {
      return this.$route.name === 'credit-authorization-confirmed'
    }
  },
  watch: {
    user() {
      const routeName = this.$route.name;

      if (routeName === 'credit-authorization') {
        document.dispatchEvent(new CustomEvent('createSquadupEmbed'));
      } else {
        if(!this.creditAuthConfirmed) {
          this.addCreditCardAuth();
        }
      }
    }
  },
  methods: {
    addCreditCardAuth() {
      let route = this.$laroute.route('api.credit.card.confirmation', {
        organization: this.user.organization_id
      });

      axios.post(route)
        .then((response) => {
          this.creditAuthConfirmed = true
          this.$store.dispatch('setUser', { user: response.data.data })
        })
    }
  },
  mounted() {
    const routeName = this.$route.name;

    if (routeName === 'credit-authorization') {
      const appendId = document.getElementById('credit-auth');
      const checkout = document.getElementById('squadup-checkout');

      appendId.appendChild(checkout);
      document.dispatchEvent(new CustomEvent('createSquadupEmbed'));
    } else {
      this.addCreditCardAuth();
    }
  }
}
</script>
